import {Component, OnInit} from '@angular/core';
import {NotificationsService, ProjectService} from '@catcore/services';
import {Message} from '@catui/components/alert/types';
import {isNullOrUndefined} from 'util';

const URL = '/api/projects/from_upload';
const FormProperty = {
  CmsCoordSheetFile: 'cmsCoordSheet'
};

@Component({
  templateUrl: './global-project.component.html',
  styleUrls: ['./global-project.component.scss'],
})
export class GlobalProjectComponent implements OnInit {

  uploaderHandler = {
    uploadAll: (url: string) => {
      console.warn('upload not overwritten by implementation yet');
    },
  };

  uploadErrors: Message[];

  formData: FormData;
  cmsCoordSheetFiles: FileList;

  get formIsValid() {
    let isValid = !isNullOrUndefined(this.formData);
    isValid = isValid && this.formData.has(FormProperty.CmsCoordSheetFile);
    return isValid;
  }

  constructor(private notificationService: NotificationsService,
              private projectService: ProjectService) {
  }

  ngOnInit() {
    this.formData = new FormData();
  }

  updateCmsCoordSheetFile(files: FileList) {
    this.cmsCoordSheetFiles = files;
    this.updateFormData(FormProperty.CmsCoordSheetFile, files);
  }

  upload() {
    this.projectService
      .submitConfigFilesAsFormData(this.formData)
      .subscribe((result) => {
        this.notificationService.success(
          'Upload successful',
          'File was successfully uploaded',
        );
        this.projectService.refreshList();
      }, (error) => {
        console.error('upload failed', error);
        this.notificationService.error(
          'Error while uploading the files',
          error.error.default_error.detail,
        );

      })
    ;
  }

  private updateFormData(propertyName: string, files: FileList) {
    if (files.length > 0) {
      this.formData.append(propertyName, files[0]);
    }
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/project/components/global-project/global-project.component.ts